import {
  CPSConfig,
  CPSConfigFunctionnality,
  IProduct,
  ProductTuto,
  OTAUpdateProperty,
  IProductFunctionnality,
  HistoryGraphModeEnum,
  HistoryGraphYModeEnum,
  HistoryChartModeEnum,
} from '../IProduct';
import { P0003607FunctionFinish } from './P0003607/Installation/P0003607InstallationFinish';
import { P00039DataRxTxIndex } from './P00039Sync';
import { P00039 } from './P00039';
import { P00032 } from './P00032';
import { P0003607FunctionReset } from './P0003607/Installation/P0003607InstallationReset';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P0003607ElectrolyseurMiseEnOeuvreInit } from './P0003607/Electrolyseur/miseenoeuvre/P0003607ElectrolyseurMiseEnOeuvreInit';
import { P0003607ElectrolyseurMiseEnOeuvreDesinfectionComponent } from './P0003607/Electrolyseur/miseenoeuvre/p0003607-electrolyseur-mise-en-oeuvre-desinfection/p0003607-electrolyseur-mise-en-oeuvre-desinfection.component';
import { P0003607ElectrolyseurMiseEnOeuvreProtectionComponent } from './P0003607/Electrolyseur/miseenoeuvre/p0003607-electrolyseur-mise-en-oeuvre-protection/p0003607-electrolyseur-mise-en-oeuvre-protection.component';
import { P0003607ElectrolyseurControleComponent } from './P0003607/Electrolyseur/cps/p0003607-electrolyseur-controle/p0003607-electrolyseur-controle.component';
import { P0003607ElectrolyseurParametersComponent } from './P0003607/Electrolyseur/cps/p0003607-electrolyseur-parameters/p0003607-electrolyseur-parameters.component';
import { P0003607ElectrolyseurStatutComponent } from './P0003607/Electrolyseur/cps/p0003607-electrolyseur-statut/p0003607-electrolyseur-statut.component';
import { P0003607InstallationCelluleComponent } from './P0003607/Installation/p0003607-installation-cellule/p0003607-installation-cellule.component';
import { P0003607InstallationVoletComponent } from './P0003607/Installation/p0003607-installation-volet/p0003607-installation-volet.component';
import { P0003607CardElectrolyseurStatutComponent } from './P0003607/Electrolyseur/cards/p0003607-card-electrolyseur-statut/p0003607-card-electrolyseur-statut.component';
import { P0003607CardElectrolyseurControleComponent } from './P0003607/Electrolyseur/cards/p0003607-card-electrolyseur-controle/p0003607-card-electrolyseur-controle.component';
import { P0003607Alarm } from './P0003607/Alarm/P0003607Alarm';

export class P0003607Data {
  esCModeFonctionnement: number = 0;

  esCConfirmationOTA: number = 0;

  esCResetCompteur: number = 0;

  esCResetUsine: number = 0;

  esPTypeHorloge: number = 0;

  esPActivationFonctionHivernage: number = 0;

  esPActivationSecuriteDesinfection: number = 0;

  esPConsigneRx: number = 0;

  esPHysteresisRegulationRx: number = 0;

  esPHorlogeJour: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  esPHorlogeSemaine: string = '000000000000';

  esPDureeInversionPolarite: number = 0;

  esPTauxAbaissement: number = 0;

  esPTemperatureHivernage: number = 0;

  esIConfigurationProduit: number = 0;

  esIActivationFonctionPrioriteElectrolyse: number = 0;

  esIActivationFonctionAutoMaintien: number = 0;

  esISensContactSel: number = 0;

  esIActivationInversionPolarite: number = 0;

  esISourceReferenceVolet: number = 0;

  esISondeReferenceRx: number = 0;

  esIMethodeAsservissement: number = 0;

  esICapteurTemperatureReference: number = 0;

  esISourceReferenceDebit: number = 0;

  esSCommandeElectrolyseur: number = 0;

  esSEtatSortieElectrolyseur: number = 0;

  esSEtatBouton: number = 0;

  esSAlarme: number = 0;

  esSMesureRxReferenceRegRx: number = 0;

  esSCommandeElectrolyseurRegRx: number = 0;

  esSCommandeElectrolyseurRegHorloge: number = 0;

  esSArretElectrolyseurInversionPolarite: number = 0;

  esSAsservissementAlimentationVolet: number = 0;

  esSArretElectrolyseurAsservissementAlimentation: number = 0;

  esSAsservissementContactSelVolet: number = 0;

  esSCommandeAsservissementVolet: number = 0;

  esSProtectionHivernage: number = 0;

  esSTemperatureReferenceDisponibleProtectionHivernage: number = 0;

  esSArretElectrolyseurProtectionHivernage: number = 0;

  esSArretElectrolyseurProtectionDebit: number = 0;

  esSMiseRouteFiltrationPrioElectrolyse: number = 0;

  esSMiseRouteFiltrationPrioAutoMaintien: number = 0;

  esSEtatVolet: number = 0;

  esSSecuriteDesinfection: number = 0;

  esSCourantConsomme: number = 0;

  esSNombreCommutationRelais: number = 0;

  esSTensionSecteur: number = 0;

  esSPuissanceApparente: number = 0;

  esSPuissanceActive: number = 0;

  esSCompteurPuissanceApparenteTotal: number = 0;

  esSCompteurPuissanceActiveTotal: number = 0;

  esSCompteurAmpereHeure: number = 0;

  esSTempsSousTension: number = 0;

  esSCompteurBouton: number = 0;

  esSMesureRxReference: number = 0;

  esSCompteurInversionPolarite: number = 0;

  esSMesureTemperature: number = 0;

  esSDetectionDebitReference: number = 0;

  esSCumulTempsFonctionnementTemperatureBasse: number = 0;

  esSCompteurResetUsine: number = 0;

  esSCompteurResetCompteur: number = 0;
}

export class P0003607 extends IProduct {
  override deviceTableIndex: number = 11;

  override modelIdentifier?: string = 'P00036-07';

  override dataIdentifier?: string = 'P0003607';

  override manufacturerName?: string = 'ACWA';

  data: P0003607Data = new P0003607Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P0003607/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P0003607/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P0003607/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P0003607;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P0003607?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P0003607.tuto.installation.help.title',
      helpSlides: [
        'P0003607.tuto.installation.help.1',
        'P0003607.tuto.installation.help.2',
        'P0003607.tuto.installation.help.3',
        'P0003607.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003607/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0003607/installation-1_dark.png',
          },
          text: 'P0003607.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003607/installation-2.png',
            dark: '/assets/ecosystem/images/products/P0003607/installation-2_dark.png',
          },
          text: 'P0003607.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003607/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0003607/installation-1_dark.png',
          },
          text: 'P0003607.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P0003607/update-2.png',
            dark: '/assets/ecosystem/images/products/P0003607/update-2_dark.png',
          },
          text: 'P0003607.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          {
            component: P0003607InstallationCelluleComponent,
            condition: () => {
              return true;
            },
          },
          {
            component: P0003607InstallationVoletComponent,
            condition: () => {
              return true;
            },
          },
        ],
        finish: P0003607FunctionFinish,
        reset: P0003607FunctionReset,
      },

      statusCards: [
        { component: P0003607CardElectrolyseurStatutComponent, weight: 17 },
      ],

      controlCards: [
        { component: P0003607CardElectrolyseurControleComponent, weight: 16 },
      ],

      alarms: {
        component: P0003607Alarm,
        weight: 20,
      },

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.DISINFECTION];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality | EventProductFunctionnalityEnum,
  ): CPSConfigFunctionnality | null {
    if (
      functionnality == IProductFunctionnality.ELECTROLYSEUR_STANDARD ||
      functionnality == EventProductFunctionnalityEnum.DISINFECTION
    ) {
      return {
        miseEnOeuvre: {
          pages: [
            {
              component: P0003607ElectrolyseurMiseEnOeuvreDesinfectionComponent,
              condition: () => {
                return true;
              },
            },
            {
              component: P0003607ElectrolyseurMiseEnOeuvreProtectionComponent,
              condition: (pool: Pool) => {
                return (
                  true ||
                  (new P00039().hasProduct(pool, new P00032()) > 0 &&
                    pool.deviceTable.P0003607.data
                      .esSTemperatureReferenceDisponibleProtectionHivernage ==
                      1)
                );
              },
            },
          ],
          init: P0003607ElectrolyseurMiseEnOeuvreInit,
        },
        controle: {
          enabledUser: true,
          enabledSupport: true,

          component: P0003607ElectrolyseurControleComponent,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,

          reglage: {
            enabledUser: true,
            enabledSupport: true,
            component: P0003607ElectrolyseurParametersComponent,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          component: P0003607ElectrolyseurStatutComponent,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            graphiques: [
              {
                title: 'P0003607.history.fonctionnement',
                mode: HistoryGraphModeEnum.EVENT,
                codeEvent: 108,
                yMode: HistoryGraphYModeEnum.HOUR,
                property: 'esSEtatSortieElectrolyseur',
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
              },
              {
                title: 'P0003607.history.puissance',
                mode: HistoryGraphModeEnum.DATA,
                property: 'esSCompteurPuissanceActiveTotal',
                aggregate: 'delta',
                yMode: HistoryGraphYModeEnum.WATT,
                yModeOptions: { min: 0, max: 150 },
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
              },
              {
                title: 'P0003607.history.rx',
                mode: HistoryGraphModeEnum.DATA,
                property: 'esSMesureRxReference',
                aggregate: 'avg',
                yMode: HistoryGraphYModeEnum.MVOLT,
                yModeOptions: { min: 0, max: 1000 },
                chartMode: HistoryChartModeEnum.LINEAR,
              },
            ],
          },
        },
      };
    }
    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.ElectrolyseurStandard_Controle,
      propertyName: 'esCConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 18;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).esIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_3.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_3.csv'
    );
  }
}
